import React from "react";
import composedDailyLogContainer from "../../../containers/DailyLogContainer";
import DailyLogs from "./DailyLogs";

const DailyLogMainComponent = (props) => {
  return <DailyLogs />;
};

export default composedDailyLogContainer(DailyLogMainComponent);
